// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDWt5aApASQERGytJ0v6h_t6Qu7512XD5k",
  authDomain: "old-car-23871.firebaseapp.com",
  projectId: "old-car-23871",
  storageBucket: "old-car-23871.appspot.com",
  messagingSenderId: "882637838136",
  appId: "1:882637838136:web:61c794f3dd2e9f79e8d3cd",
  measurementId: "G-QM9NK8LQ4T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;